import React from "react";
import "./SlotGamesDevelopmentSuperiorStyle.scss";
import { slotGamesDevelopmentSuperiorTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const SlotGamesDevelopmentSuperiorSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/`);
  };

  return (
    <section className="slot-games-development-superior-section">
      <div className="slot-games-development-superior-wrap">
        <SectionHeading>{slotGamesDevelopmentSuperiorTextContent.headingText}</SectionHeading>

        <div className="slot-games-development-superior-box">
          <div className="cards-grid">
            {slotGamesDevelopmentSuperiorTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-body">
                  <h1 className="number-text">{section.numberText}</h1>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>
              </div>
            ))}
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={slotGamesDevelopmentSuperiorTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesDevelopmentSuperiorSection;
